<template>
  <div>
    <div class="lxm-login__logo">
      <img src="https://s.lingxi360.com/register/%E7%BC%96%E7%BB%84%402x.png">
    </div>
    <p class="lxm-login__logo-text">每个智慧公益背后都有灵析</p>
    <div class="lxm-login__container">
      <input-align-left :type="'email'"
                      :placeholder="'请输入您的邮箱'"
                      :value="email"
                      :error="state.emailError"
                      :transparent="true"
                      @input="emailChanged"
                      @click="emailClicked"></input-align-left>

      <input-align-left :type="'password'"
                      :placeholder="'请输入您的密码'"
                      :value="loginPassword"
                      :transparent="true"
                      :error="state.loginPasswordError"
                      @input="loginPasswordChanged"
                      @click="loginPasswordClicked"></input-align-left>

      <button-primary class="lxm-login-login-email__button-primary"
                      :text="'登录'"
                      :loading="buttonLoading"
                      @click="clicked"></button-primary>

      <other-button></other-button>
    </div>
  </div>
</template>

<style lang="stylus" scoped>
  @import '../styles/index.styl'
  .lxm-login__container
    width: login-width
    margin: 0 auto
    padding-top: siz(52)
  .lxm-login__logo
    display: block
    padding-top: siz(59)
    img
      width: 100%
  .lxm-login__logo-text
    margin-top: siz(30)
    color: #394263
    text-align: center
    font-size: siz(16)
    font-weight: 400
    line-height: siz(26)
    height: siz(26)
  .lxm-login-login-email__button-primary
    margin-top: siz(40)
</style>

<script>
  import InputLabelled from './common/InputLabelled.vue'
  import ButtonPrimary from './common/ButtonPrimary.vue'
  import OtherButton from './common/OtherButton.vue'
  import InputAlignLeft from './common/InputAlignLeft.vue'
  import * as aTypes from '../../store/action-types'
  import * as mTypes from '../../store/mutation-types'
  export default {
    components: {
      InputLabelled,
      ButtonPrimary,
      OtherButton,
      InputAlignLeft
    },
    computed: {
      state () {
        return this.$store.state.login
      },
      email () {
        return this.$store.state.login.email
      },
      loginPassword () {
        return this.$store.state.login.loginPassword
      },
      buttonLoading () {
        return this.$store.state.loading[aTypes.LOGIN_WITH_EMAIL]
      }
    },
    methods: {
      emailChanged (e) {
        this.$store.commit(mTypes.LOGIN_UPDATE, { email: e.target.value })
      },
      loginPasswordChanged (e) {
        this.$store.commit(mTypes.LOGIN_UPDATE, { loginPassword: e.target.value })
      },
      emailClicked (e) {
        this.$store.commit(mTypes.LOGIN_UPDATE, { emailError: '' })
      },
      loginPasswordClicked (e) {
        this.$store.commit(mTypes.LOGIN_UPDATE, { loginPasswordError: '' })
      },
      clicked () {
        this.$store.dispatch(aTypes.LOGIN_WITH_EMAIL, {
          mail: this.state.email,
          password: this.state.loginPassword
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LoginEmail.vue?f9423e0a